// E4.7 — the single decision that routes a thread's reply composer.
//
// A "system-channel" thread is a platform-owned channel (e.g. privacy@) whose
// replies MUST go through the certified route
// `POST /api/unibox/threads/:id/system-channel-reply` rather than the ordinary
// `POST /api/unibox/messages/send`. Detection is by the canonical
// `systemChannelId` field ONLY: a non-null value means system channel.
//
// It is deliberately NOT inferred from subject, sender, medium, title,
// participant, or timestamp — any of those could be forged or coincidental,
// and misclassifying an ordinary thread as system (or the reverse) would send
// a reply down the wrong path. The field is the authority; nothing else is.
//
// This is a display/routing decision only. It does not, and must not, grant
// reply authority: the server applies `requireHybridAuth` +
// `requirePermission('messages.send')` + `canReplyToThreadRow` on every
// submission regardless of what the frontend renders.

/** The minimal shape this decision reads. */
export interface SystemChannelThreadLike {
  readonly systemChannelId?: string | null;
}

/**
 * True iff `thread` is a platform-owned system-channel thread, decided solely
 * by a non-null canonical `systemChannelId`. Null/undefined thread → false.
 */
export function isSystemChannelThread(
  thread: SystemChannelThreadLike | null | undefined,
): boolean {
  return thread != null && thread.systemChannelId != null;
}
